<template>
	<div>
		<el-row class="head">
			<el-col :xs="5" :sm="5" :md="4" :lg="4" :xl="4">
				<el-col :span="1">
					<span @click="$router.push('/')">
						<img src="../../assets/img/logo.png" alt="">
					</span>
					<span class="p400">
						4008003135
					</span>
				</el-col>
			</el-col>
			<el-col :xs="10" :sm="10" :md="12" :lg="12" :xl="14" class="custom-col-14">
				<span style="font-weight:bold;margin-left:5px;overflow: hidden;white-space: nowrap;">
					致力于为工业电气自动化元器件行业滞纳库存解决方案做加速服务
				</span>
			</el-col>
			<el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" v-if="!info">
				<el-badge @click="chat_click()" :value="$chat.state.chatnum?$chat.state.chatnum:''" class="item">
					<span>消息</span>
				</el-badge>
			</el-col>
			<!-- <el-col :span="2" class="information">
				<el-icon class="Bell" style="vertical-align: middle;"><Bell /></el-icon>
				<span style="vertical-align: middle;">消息</span>
				<el-icon style="vertical-align: middle;"><CaretBottom /></el-icon>
			</el-col> -->
			<el-col :xs="4" :sm="4" :md="3" :lg="3" :xl="2" v-if="!info">
				<el-row>
					<el-col :span="24">
						<span v-if="user_id">
							<!-- @click="$router.push('/user')"  -->
							<el-dropdown @command="handleCommand">
								<span class="el-dropdown-link">
									<el-badge :value="($globalData.to_report_num+$globalData.to_edit_num)?($globalData.to_report_num+$globalData.to_edit_num):''" class="item">
												{{mobile}}
											</el-badge>
									<el-icon class="el-icon--right">
										<arrow-down />
									</el-icon>
								</span>
								<template #dropdown>
									<el-dropdown-menu>
										<el-dropdown-item command="3">个人中心</el-dropdown-item>
										<el-dropdown-item command="4">库存中心</el-dropdown-item>
										<!-- <el-dropdown-item command="6">购买订单</el-dropdown-item>
										<el-dropdown-item command="7">销售订单</el-dropdown-item> -->
										<el-dropdown-item command="5">
											<el-badge :value="($globalData.to_report_num+$globalData.to_edit_num)?($globalData.to_report_num+$globalData.to_edit_num):''" class="item">
												反馈列表
											</el-badge>
										</el-dropdown-item>
										<!-- <el-dropdown-item command="6">关于我们</el-dropdown-item> -->
										<el-dropdown-item command="2">退出登录</el-dropdown-item>
									</el-dropdown-menu>
								</template>
							</el-dropdown>
						</span>
						<span v-else>
							<span @click="$router.push('/login')">
								登录
							</span>
							<span @click="$router.push('/register')">
								注册
							</span>
						</span>
					</el-col>
				</el-row>
			</el-col>
			<el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="1" v-if="user_id" class="custom-col-1">
					<span @click="$router.push({ path: '/user', query: { type: 'purchase' } })" style="font-weight:bold;color:rgba(255, 138, 92)">新手教程</span>
			</el-col>
			<el-col :span="2">
				<span>
					<el-tooltip placement="top" effect="light">
						<template #content>
							<el-row style="text-align:center">
								<el-col :span="24">
									<el-row>
										<el-col :span="24">
											<span>
												<img  src="../../assets/img/qr2.png" alt="" style="width:100px" class="code">
											</span>
										</el-col>
									</el-row>
								</el-col>
								
							</el-row>
						</template>
						下载中心
					</el-tooltip>
				</span>
			</el-col>
		</el-row>
		<el-row class="logo_m" v-if="$route.path!='/login' && $route.path!='/register' && $route.path!='/forgetPassword'">
			<el-col :xs="10" :sm="10" :md="8" :lg="7" :xl="5">
				<div @click="$router.push('/')" class="logo_m_img">
					<img src="../../assets/img/1.png" alt="">
				</div>
			</el-col>
			<el-col :xs="9" :sm="9" :md="11" :lg="12" :xl="15" class="Search">
				<el-input v-model="filter" @keydown.enter="search" @input="filterInput" style="height: 40px;" placeholder="品牌、品名、型号、订货号、空白也可搜索全部">
					<template #prepend>
						<div>
							<el-select @change="filterInput" clearable v-model="img_info" placeholder="图片" class="Select" style="width: 80px;margin-right:15px">
								<el-option label="有图" value="1" />
								<el-option label="无图" value="2" />
							</el-select>
						</div>
						<div>
							<el-select @change="filterInput" clearable v-model="select" placeholder="货物状态" class="Select" style="width: 190px">
								<el-option :label="item.value" :value="item.value" v-for="(item,key) in stock_type" />
							</el-select>
						</div>
					</template>
					<template #append>
						<el-button @click="search" type="primary" class="button" style="width:80px;">
							<el-icon color="#fff" size="18px" class="no-inherit">
								<Search />
							</el-icon>
						</el-button>
					</template>
				</el-input>
			</el-col>
			<!-- <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="3" :offset="1">
				<el-row style="">
					<el-col :span="24" class="accounts">
						<el-row justify="center">
							<el-col :span="24">
								公众号
							</el-col>
							<el-col :span="24">
								<span>
									<img src="../../assets/img/qr2.png" alt="" class="code">
								</span>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</el-col> -->
		</el-row>
		<chat ref="chat" v-if="chat_info" v-on:closeChat="closeChat($event)"></chat>
	</div>
</template>
<script>
import '../../assets/index.css' //优化表格样式
import { ElMessage, ElMessageBox } from 'element-plus'
import chat from '../public/chat';
/*import { Search } from '@element-plus/icons-vue'*/
export default {

	components: {
		chat,
	},
	data() {

		return {
			stock_type: [{
					text: '滞纳、在保、包附完好',
					value: '滞纳、在保、包附完好'
				},
				{
					text: '滞纳、在保、包附破损',
					value: '滞纳、在保、包附破损'
				},
				{
					text: '滞纳、过保、包附完好',
					value: '滞纳、过保、包附完好'
				},
				{
					text: '滞纳、过保、包附破损',
					value: '滞纳、过保、包附破损'
				},
				{
					text: '二手、在保、包附完好',
					value: '二手、在保、包附完好'
				},
				{
					text: '二手、在保、包附破损',
					value: '二手、在保、包附破损'
				},
				{
					text: '二手、过保、包附完好',
					value: '二手、过保、包附完好'
				},
				{
					text: '二手、过保、包附破损',
					value: '二手、过保、包附破损'
				}
			],
			select: '',
			img_info: '',
			chat_info: false,
			filter: '',
			user_id: '',
			username: '',
			mobile: '',
		}
	},
	props: ['info'],

	updated() {

	},
	watch: {

	},

	mounted() {
		this.$chat.on('chat-message', this.handleMessage);
	},

	activated() {
		this.user_id = localStorage.getItem('user_id');
		this.username = localStorage.getItem('username');
		this.mobile = localStorage.getItem('mobile');


	},
	beforeUnmount() {
		// 组件卸载时取消监听
		this.$chat.off('chat-message', this.handleMessage);
	},

	created() {
		this.filter = this.$route.query.filter
		this.select = this.$route.query.stock_type
		this.img_info = this.$route.query.img_info
		this.user_id = localStorage.getItem('user_id');
		this.username = localStorage.getItem('username');
		this.mobile = localStorage.getItem('mobile');
		this.getchatnum()


	},

	methods: {
		chat_click() {
			this.chat_info = false;
			this.$nextTick(() => {
				this.chat_info = true;
				this.$nextTick(() => {
					this.$refs['chat'].dialogTableVisible = true;
					this.$refs['chat'].admin_pitch_id = ''; //维护一个不变的数据 这个需要告诉后台是从哪里点进来的
					this.$nextTick(() => {
						this.$refs['chat'].search()
					})
				})
			})
		},
		closeChat() {
			this.chat_info = false;
		},
		//第一次连接成功
		handleMessage(message) {
			if (message.type == 'init') {
				this.bind(message.client_id);
			} else if (message.type == 'say') {
				//接受到消息请求下未读数量
				this.getchatnum()
			}
		},
		async getchatnum() {
			if (!localStorage.getItem('user_id')) {
				return false
			}
			await this.$axios.post('/api/yunsys.Chat/getchatnum').then(async (res) => {
					var res = res.data;
					this.$chat.state.chatnum = res.data
					console.log(this.$chat.state.chatnum, 211)
				})
				.catch(err => {

				})
		},
		async bind(client_id) {
			if (!localStorage.getItem('user_id')) {
				return false
			}
			localStorage.setItem('client_id', client_id)
			await this.$axios.post('/api/yunsys.Chatroom/bind', { client_id }).then(async (res) => {
					var res = res.data;

				})
				.catch(err => {

				})
		},
		handleCommand(val) {
			if (val == 2) {
				ElMessageBox.confirm(
						'确认退出登录！',
						'提示', {
							confirmButtonText: '确认',
							cancelButtonText: '取消',
							type: 'warning',
						}
					)
					.then(() => {
						localStorage.removeItem('token')
						localStorage.removeItem('lead_id')
						localStorage.removeItem('user_id')
						localStorage.removeItem('username')
						localStorage.removeItem('mobile')
						this.$router.push('/login');
						return false
					})
					.catch(() => {

					})
			} else if (val == 1) {
				//this.$router.push({ path: '/search', query: { filter: this.filter } });
			} else if (val == 3) {
				this.$router.push({ path: '/user', query: { type: 'userinfo' } });
			} else if (val == 4) {
				this.$router.push({ path: '/user', query: { type: 'publish' } });
			} else if (val == 5) {
				this.$router.push({ path: '/user', query: { type: 'tuoshou' } });
			} else if (val == 6) {
				this.$router.push({ path: '/user', query: { type: 'purchase' } });
			} else if (val == 7) {
				this.$router.push({ path: '/user', query: { type: 'market' } });
			}
		},
		filterInput(){
			if (this.$route.path == '/search') {
				/*this.filter = this.$route.query.filter
				this.select = this.$route.query.stock_type
				this.img_info = this.$route.query.img_info*/
				this.$router.replace({ query: {filter:this.filter,stock_type:this.select,img_info:this.img_info} })
			} else {
				
			}
		},
		search() {
			if (!this.user_id) {
				this.$router.push('/login');
				return false
			}
			if (this.$route.path == '/search') {
				this.$emit("HeadIndexSearch", { filter: this.filter, stock_type: this.select, img_info: this.img_info });
			} else {
				this.$router.push({ path: '/search', query: { filter: this.filter, stock_type: this.select, img_info: this.img_info } });
			}


		},
	}
}
</script>
<style lang="less" scoped>
.el-dropdown {
	line-height: 40px;
}

.el-dropdown,
.el-dropdown * {
	border: none !important;
	outline: none !important;
	box-shadow: none !important;
}

:deep(.el-dropdown-menu__item) {
	/* padding-left:25px;
	padding-right:25px; */
}

:deep(.el-badge__content.is-fixed) {
	top: 10px
}

:deep(.Select .el-select__wrapper) {
	box-shadow: 0 0 0 0px var(--el-border-color) inset !important;
}

:deep(.Search .el-select__placeholder) {
	text-align: center;
}

:deep(.Search .el-input__wrapper) {
	min-width: 150px;
}
</style>